import { apiProxyRequest } from "Api/apiProxyRequest";

import type { AuthUser } from "./types";

export const getAuthUserRequest = async (userId: string) => {
  const user = await apiProxyRequest<AuthUser>(`/users/${userId}`);
  // Path the mail field to keep it backwards compatible with /me
  user.mail = user.email;
  return user;
};
